module.exports = __webpack_public_path__ + "static/feature-1-d11dd1d038d34ee13be71e57a4a5bfd0.mp4";